import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoMedical from "../../assets/logo-medical.png";
import NextButton from "../../components/NextButton";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";
import { getTexts } from "../../api/text";
import { SERVER_URL } from "../../api";

const DEFAULT_ENUNCIADO = "Finalmente te decantas por incluir voclosporina en el tratamiento de Martina, especialmente porque se trata de un fármaco oral que reduce la proteinuria de manera más rápida que el tratamiento estándar y que no requiere monitorización de niveles plasmáticos.";
const DEFAULT_TRATAMIENTO = "Ahora Martina sigue este tratamiento:";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario5Part2End({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state?.group);
	const scenarioNum = getScenarioByScreen(location.pathname);

	const [enunciado, setEnunciado] = useState(DEFAULT_ENUNCIADO);
	const [tratamiento, setTratamiento] = useState(DEFAULT_TRATAMIENTO);
	const [imageUrl, setImageUrl] = useState(null);

	useEffect(() => {
		const gameId = group?.game;
		if (!gameId) return;
		getTexts({ game: gameId })
			.then((res) => {
				if (res.status === 200 && Array.isArray(res.data)) {
					const map = res.data.reduce((acc, t) => ({ ...acc, [t.key]: t.value }), {});
					if (map["scenario5.2.end.enunciado"] != null && map["scenario5.2.end.enunciado"] !== "") setEnunciado(map["scenario5.2.end.enunciado"]);
					if (map["scenario5.2.end.tratamiento"] != null && map["scenario5.2.end.tratamiento"] !== "") setTratamiento(map["scenario5.2.end.tratamiento"]);
					if (map["scenario5.2.end.image"]) setImageUrl(buildImageUrl(map["scenario5.2.end.image"]));
				}
			})
			.catch(() => {});
	}, [group?.game]);

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} alt="" />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5">
					<div className="col-8">
						<div className="d-flex flex-column align-items-center">
							<div className="txt18 bold txt-white mt-4 text-center">
								{enunciado && enunciado.indexOf("<") >= 0 ? (
									<span dangerouslySetInnerHTML={{ __html: enunciado }} />
								) : (
									enunciado
								)}
							</div>
							<div className="text-center txt-white my-4">
								{tratamiento && tratamiento.indexOf("<") >= 0 ? (
									<span dangerouslySetInnerHTML={{ __html: tratamiento }} />
								) : (
									tratamiento
								)}
							</div>
							{imageUrl ? (
								<img width={500} src={imageUrl} alt="" />
							) : (
								<div style={{ width: 500, height: 350, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
							)}
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton
						navigateTo={ROUTES.TRANSITION_SCENARIOS}
						activeScenario={scenarioNum + 1}
					/>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario5Part2End);
